import styled from 'styled-components'

import { Container } from '@material-ui/core'

export const MainContainer = styled(Container)``

export default MainContainer
